import { useState } from 'react';
import { Link } from 'react-router-dom';

interface Transaction {
  id: number;
  type: 'charge' | 'subscription' | 'tip' | 'ppv';
  amount: number;
  description: string;
  date: string;
  status: 'completed' | 'pending';
}

export default function FanWallet() {
  const [showChargeModal, setShowChargeModal] = useState(false);
  const [chargeAmount, setChargeAmount] = useState('');

  const balance = 125;

  const transactions: Transaction[] = [
    {
      id: 1,
      type: 'charge',
      amount: 100,
      description: '충전',
      date: '2024-01-15 14:30',
      status: 'completed'
    },
    {
      id: 2,
      type: 'subscription',
      amount: -20,
      description: '하늘 - 스탠다드 구독',
      date: '2024-01-14 10:20',
      status: 'completed'
    },
    {
      id: 3,
      type: 'tip',
      amount: -5,
      description: '지우에게 팁 보내기',
      date: '2024-01-13 18:45',
      status: 'completed'
    },
    {
      id: 4,
      type: 'charge',
      amount: 50,
      description: '충전',
      date: '2024-01-12 09:15',
      status: 'completed'
    },
    {
      id: 5,
      type: 'subscription',
      amount: -9,
      description: '지우 - 베이직 구독',
      date: '2024-01-10 16:30',
      status: 'completed'
    }
  ];

  const quickChargeAmounts = [10000, 100000, 500000, 1000000, 3000000, 5000000];

  const handleCharge = () => {
    if (!chargeAmount || Number(chargeAmount) < 10000) {
      alert('최소 충전 금액은 10,000원입니다.');
      return;
    }
    
    // Pay-I 결제 페이지로 이동 (금액 전달)
    const paymentUrl = `https://payiapp.com/payment?amount=${chargeAmount}`;
    window.location.href = paymentUrl;
  };

  const getTransactionIcon = (type: string) => {
    switch (type) {
      case 'charge':
        return 'ri-add-circle-line';
      case 'subscription':
        return 'ri-heart-3-line';
      case 'tip':
        return 'ri-gift-line';
      case 'ppv':
        return 'ri-lock-unlock-line';
      default:
        return 'ri-money-dollar-circle-line';
    }
  };

  const getTransactionColor = (type: string) => {
    switch (type) {
      case 'charge':
        return 'text-green-600 bg-green-50';
      case 'subscription':
        return 'text-pink-600 bg-pink-50';
      case 'tip':
        return 'text-purple-600 bg-purple-50';
      case 'ppv':
        return 'text-blue-600 bg-blue-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-pink-50 to-purple-50 pb-20 md:pb-8">
      {/* Top Navigation */}
      <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-pink-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/fan/dashboard" className="flex items-center gap-2 text-gray-600 hover:text-pink-500">
              <i className="ri-arrow-left-line text-xl"></i>
              <span className="font-medium">뒤로</span>
            </Link>
            <h1 className="text-xl font-bold text-gray-800">내 지갑</h1>
            <div className="w-20"></div>
          </div>
        </div>
      </nav>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Balance Card */}
        <div className="bg-gradient-to-br from-pink-500 via-purple-500 to-blue-500 rounded-3xl p-8 text-white mb-6 shadow-xl">
          <div className="flex items-center justify-between mb-4">
            <div>
              <p className="text-white/80 text-sm mb-1">보유 피치</p>
              <div className="flex items-center gap-2">
                <h2 className="text-4xl font-bold">{balance.toLocaleString()}</h2>
                <span className="text-3xl">🍑</span>
              </div>
            </div>
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
              <i className="ri-wallet-3-line text-3xl"></i>
            </div>
          </div>
          <p className="text-white/60 text-sm mb-4">1,000원 = 1피치</p>
          
          {/* Charge Button */}
          <button
            onClick={() => setShowChargeModal(true)}
            className="w-full py-3 bg-white text-pink-600 rounded-xl font-bold text-lg hover:bg-white/90 transition-all whitespace-nowrap"
          >
            <i className="ri-add-circle-line mr-2"></i>
            충전하기
          </button>
        </div>

        {/* Quick Stats */}
        <div className="grid grid-cols-3 gap-4 mb-8">
          <div className="bg-white rounded-2xl p-5 text-center">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-gradient-to-br from-pink-100 to-purple-100 flex items-center justify-center">
              <i className="ri-heart-3-fill text-2xl text-pink-500"></i>
            </div>
            <p className="text-gray-600 text-sm mb-1">이번 달 구독</p>
            <div className="flex items-center justify-center gap-1">
              <p className="text-xl font-bold text-gray-800">29</p>
              <span className="text-lg">🍑</span>
            </div>
          </div>
          <div className="bg-white rounded-2xl p-5 text-center">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-gradient-to-br from-purple-100 to-blue-100 flex items-center justify-center">
              <i className="ri-gift-fill text-2xl text-purple-500"></i>
            </div>
            <p className="text-gray-600 text-sm mb-1">이번 달 팁</p>
            <div className="flex items-center justify-center gap-1">
              <p className="text-xl font-bold text-gray-800">5</p>
              <span className="text-lg">🍑</span>
            </div>
          </div>
          <div className="bg-white rounded-2xl p-5 text-center">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-gradient-to-br from-blue-100 to-pink-100 flex items-center justify-center">
              <i className="ri-add-circle-fill text-2xl text-blue-500"></i>
            </div>
            <p className="text-gray-600 text-sm mb-1">이번 달 충전</p>
            <div className="flex items-center justify-center gap-1">
              <p className="text-xl font-bold text-gray-800">150</p>
              <span className="text-lg">🍑</span>
            </div>
          </div>
        </div>

        {/* Transaction History */}
        <div className="bg-white rounded-3xl p-6">
          <h3 className="text-xl font-bold text-gray-800 mb-6">거래 내역</h3>
          <div className="space-y-4">
            {transactions.map((transaction) => (
              <div
                key={transaction.id}
                className="flex items-center justify-between p-4 rounded-xl hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center gap-4">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center ${getTransactionColor(transaction.type)}`}>
                    <i className={`${getTransactionIcon(transaction.type)} text-xl`}></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">{transaction.description}</p>
                    <p className="text-sm text-gray-500">{transaction.date}</p>
                  </div>
                </div>
                <div className="text-right">
                  <div className="flex items-center gap-1 justify-end">
                    <p className={`text-lg font-bold ${transaction.amount > 0 ? 'text-green-600' : 'text-gray-800'}`}>
                      {transaction.amount > 0 ? '+' : ''}{transaction.amount.toLocaleString()}
                    </p>
                    <span className="text-lg">🍑</span>
                  </div>
                  <p className={`text-xs ${transaction.status === 'completed' ? 'text-green-600' : 'text-yellow-600'}`}>
                    {transaction.status === 'completed' ? '완료' : '대기중'}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      {/* Charge Modal */}
      {showChargeModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl max-w-md w-full">
            <div className="border-b border-gray-100 p-6 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-800">충전하기</h2>
              <button
                onClick={() => setShowChargeModal(false)}
                className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            <div className="p-6">
              {/* Quick Charge Amounts */}
              <div className="mb-6">
                <p className="text-sm font-semibold text-gray-700 mb-3">빠른 충전</p>
                <div className="grid grid-cols-2 gap-3">
                  {quickChargeAmounts.map((amount) => {
                    const peaches = amount / 1000;
                    return (
                      <button
                        key={amount}
                        onClick={() => setChargeAmount(amount.toString())}
                        className={`py-4 rounded-xl font-semibold transition-all whitespace-nowrap ${
                          chargeAmount === amount.toString()
                            ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        }`}
                      >
                        <div className="text-lg">{(amount / 10000).toFixed(0)}만원</div>
                        <div className="text-sm opacity-80">{peaches}피치 🍑</div>
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Custom Amount */}
              <div className="mb-6">
                <p className="text-sm font-semibold text-gray-700 mb-3">직접 입력</p>
                <div className="relative">
                  <input
                    type="number"
                    value={chargeAmount}
                    onChange={(e) => setChargeAmount(e.target.value)}
                    placeholder="충전 금액 입력"
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-pink-500 focus:outline-none text-lg"
                  />
                  <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 font-semibold">원</span>
                </div>
                {chargeAmount && Number(chargeAmount) >= 10000 && (
                  <p className="text-xs text-pink-600 mt-2 font-semibold">
                    {Math.floor(Number(chargeAmount) / 1000)}피치를 받게 됩니다 🍑
                  </p>
                )}
                <p className="text-xs text-gray-500 mt-1">최소 충전: 10,000원 (10피치)</p>
              </div>

              {/* Payment Method */}
              <div className="mb-6">
                <p className="text-sm font-semibold text-gray-700 mb-3">결제 수단</p>
                <div className="w-full p-4 rounded-xl border-2 border-blue-500 bg-blue-50 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center">
                    <i className="ri-bank-card-line text-xl text-white"></i>
                  </div>
                  <span className="font-semibold text-gray-800">Pay-I 결제</span>
                  <i className="ri-check-line text-blue-500 ml-auto text-xl"></i>
                </div>
              </div>

              {/* Charge Button */}
              <button
                onClick={handleCharge}
                disabled={!chargeAmount || Number(chargeAmount) < 10000}
                className="w-full py-4 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-xl font-bold text-lg hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {chargeAmount && Number(chargeAmount) >= 10000 
                  ? `${Number(chargeAmount).toLocaleString()}원 충전하기 (${(Number(chargeAmount) / 1000).toLocaleString()}🍑)` 
                  : '금액을 입력하세요'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
